"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHANNEL_MAIN_MENU_ITEM_DID_CLICK = exports.CHANNEL_PLOTTER_WINDOW_DID_CLOSE = exports.CHANNEL_SEND_STARTUP_TASKS = exports.CHANNEL_SET_MENU_WITH_NODE_ID = exports.CHANNEL_OPEN_PATH = exports.CHANNEL_SHOW_PLOTTER_WINDOW = exports.CHANNEL_SET_REPRESENTED_FILENAME = exports.CHANNEL_SCHEDULE_DELETION = exports.CHANNEL_IS_FIRST_WINDOW = exports.CHANNEL_QUIT_APP = exports.CHANNEL_APP_INFO = exports.CHANNEL_SHOW_SAVE_DIALOG = exports.CHANNEL_SHOW_OPEN_DIALOG = exports.CHANNEL_SHOW_MESSAGE_BOX = exports.isShowPlotterWindowParams = exports.appInfoPropertyLiterals = void 0;
exports.appInfoPropertyLiterals = [
    'appVersion',
    'cliVersion',
    'buildDate',
];
function isShowPlotterWindowParams(arg) {
    return (typeof arg === 'object' &&
        typeof arg.url === 'string' &&
        (arg.forceReload === undefined ||
            typeof arg.forceReload === 'boolean'));
}
exports.isShowPlotterWindowParams = isShowPlotterWindowParams;
// renderer to main
exports.CHANNEL_SHOW_MESSAGE_BOX = 'Arduino:ShowMessageBox';
exports.CHANNEL_SHOW_OPEN_DIALOG = 'Arduino:ShowOpenDialog';
exports.CHANNEL_SHOW_SAVE_DIALOG = 'Arduino:ShowSaveDialog';
exports.CHANNEL_APP_INFO = 'Arduino:AppInfo';
exports.CHANNEL_QUIT_APP = 'Arduino:QuitApp';
exports.CHANNEL_IS_FIRST_WINDOW = 'Arduino:IsFirstWindow';
exports.CHANNEL_SCHEDULE_DELETION = 'Arduino:ScheduleDeletion';
exports.CHANNEL_SET_REPRESENTED_FILENAME = 'Arduino:SetRepresentedFilename';
exports.CHANNEL_SHOW_PLOTTER_WINDOW = 'Arduino:ShowPlotterWindow';
exports.CHANNEL_OPEN_PATH = 'Arduino:OpenPath';
exports.CHANNEL_SET_MENU_WITH_NODE_ID = 'Arduino:SetMenuWithNodeId';
// main to renderer
exports.CHANNEL_SEND_STARTUP_TASKS = 'Arduino:SendStartupTasks';
exports.CHANNEL_PLOTTER_WINDOW_DID_CLOSE = 'Arduino:PlotterWindowDidClose';
exports.CHANNEL_MAIN_MENU_ITEM_DID_CLICK = 'Arduino:MainMenuItemDidClick';
//# sourceMappingURL=electron-arduino.js.map